import React, { useState } from "react";
import { useLayoutHeader } from "components/MainLayout";
import { Button, Input, Row, Typography, Radio, Col, message } from "antd";
import "./IncreaseCredit.css";
import { getBillingApi } from "../../api";
import { PURCHASE_CHANNEL, defaultAmount } from "../../constants";
import { useHistory } from "react-router";
import routesConfig from "../../routesConfig";
import { selectWalletBalance } from "store/user/reducer";
import { connect } from "react-redux";
import Currency from "components/Currency";

const { Title } = Typography;

const headerConfig = {
    closeable: true,
    pageTitle: "اعتبار",
    menuEnabled: false,
    extra: [],
};

function IncreaseCredit(props) {
    const history = useHistory();
    useLayoutHeader(headerConfig);
    const [amount, setAmount] = useState(defaultAmount);

    const onCredit = (amount) => {
        const purchaseChannel = PURCHASE_CHANNEL;
        getBillingApi()
            .createWalletOrder({ amount, purchaseChannel })
            .then((response) => {
                history.push(routesConfig.order + "/" + response.id);
            })
            .catch(() => {
                message.error("خطا در عملیات افزایش اعتبار !");
            });
    };

    return (
        <>
            <Row>
                <Col span={24} className="px-40">
                    <Title level={2} className="f-30 mb-1">
                        {" "}
                        افزایش اعتبار{" "}
                    </Title>
                    <p className="color-primary f-14 mb-36">
                        {"اعتبار فعلی شما "}
                        <Currency value={props.walletBalance} />
                    </p>
                </Col>
            </Row>
            <Row>
                <Col span={24} className="px-40">
                    <label className="f-22">انتخاب مبلغ</label>
                </Col>
            </Row>
            <Row justify="center px-40 mb-36">
                <Radio.Group
                    defaultValue={defaultAmount}
                    onChange={(e) => setAmount(e.target.value)}
                    style={{ margin: "16px 0" }}
                >
                    {[55000, defaultAmount, defaultAmount * 2].map((val) => (
                        <Radio.Button
                            style={{ margin: 2 }}
                            value={val}
                            key={val}
                            className="custom-radio"
                        >
                            <Currency value={val} />
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </Row>
            <Row>
                <Col span={24} className="px-40">
                    <label className="f-22">مبلغ های دیگر</label>
                </Col>
            </Row>
            <Row justify="center" className="px-40">
                <Input
                    defaultValue={defaultAmount}
                    addonAfter={"تومان"}
                    style={{ textAlign: "center" }}
                    type={"number"}
                    className="input-code f-18"
                    value={amount}
                    onChange={(event) => setAmount(event.target.value)}
                />
            </Row>

            <Row justify="center" className="px-40 mt-16">
                <Button
                    block
                    type="primary"
                    onClick={(event) => amount && onCredit(amount)}
                >
                    <span className="px-1">پرداخت</span>
                    <Currency value={amount} />
                </Button>
            </Row>
        </>
    );
}

const mapStateToProps = (state) => ({
    walletBalance: selectWalletBalance(state),
});

export default connect(mapStateToProps)(IncreaseCredit);
